/* Applicationindex.jsx */
import React from "react";
import ApplicationHero from "./ApplicationHero";
import ApplicationApproach from "./ApplicationApproach";
// import ApplicationBenefits from "./ApplicationBenefits";
import ApplicationEnd from "./ApplicationEnd";
// import EducationIncluded from "./Edcatoincluded";
import ApplicationTopHero from "./ApplicationTopHero";
import "../styles/Badge.css";
import EngineeringResults from "./EngineeringResults";
import CorePrinciples from "./CorePrinciples";

const Applicationindex = () => {
  // const educationRef = useRef(null);

  // const scrollToEducation = () => {
  //   educationRef.current?.scrollIntoView({ behavior: "smooth" });
  // };

  return (
    <div>
      {/* Badge is now rendered inside the hero */}
      {/* <ApplicationTopHero onBadgeClick={scrollToEducation} /> */}
      <ApplicationTopHero />

      <ApplicationHero />
      <ApplicationApproach />
      {/* <ApplicationBenefits /> */}

      {/* <div ref={educationRef}>
        <EducationIncluded />
      </div> */}

      <EngineeringResults />
      <CorePrinciples />

      <ApplicationEnd />
    </div>
  );
};

export default Applicationindex;
